import {LineChart, TreemapChart} from 'echarts/charts';
import {CanvasRenderer} from 'echarts/renderers';
import {use} from 'echarts/core';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    SingleAxisComponent,
    GridComponent,
    AxisPointerComponent,
    TransformComponent,
    DatasetComponent,
    DataZoomComponent,
    VisualMapComponent,
} from 'echarts/components';

export default function registerEchartsComponents ()  {
    use([
        CanvasRenderer,
        GridComponent,
        TitleComponent,
        TooltipComponent,
        LegendComponent,
        SingleAxisComponent,
        AxisPointerComponent,
        TransformComponent,
        LineChart,
        TreemapChart,
        DatasetComponent,
        DataZoomComponent,
        VisualMapComponent
    ]);
}
